import React, { Component } from 'react'

import Datagrid from '@/ui/DataTable/Datagrid'
import ListTable from '@/ui/DataTable/List'

import { AvatarField, ButtonField, CombinedField, TextField } from '@/ui/Data'
import { Container, Row, Cell } from '@/ui/Element'
import { EditButton, Button, ButtonGroup } from '@/ui/Button'
import { Tooltip } from '@/ui/Tooltip'

import { showModal, hideModal } from '@/state/actions/modal'
import { crudDelete } from '@/state/actions/data'
import { routeProductsEdit } from '@/state/actions/routes'

import DeleteIcon from '@/icons/Delete'
import EditIcon from '@/icons/Edit'
import PlaneIcon from '@/media/svg/mail-use.svg'

import { showNotification } from '@/state/actions/notification'

class Products extends Component {
  close = () => {
    this.props.dispatch(hideModal())
  }

  delete = record => {
    this.props.dispatch(
      crudDelete('products', record.id, false, { message: `${record.title} deleted.` }),
    )
    this.props.dispatch(hideModal())
  }

  edit = record => {
    this.props.dispatch(routeProductsEdit(record.id))
  }

  remove = record => {
    this.props.dispatch(
      showModal({
        title: 'Permanently delete $title?',
        record: record,
        content:
          `This will permanently delete $title from the product list and ` +
          `it will no logner be accessible to anyone. All related items will ` +
          `remain. This action is irreversible.`,
        buttons: [
          <Button classes="inverted" key="cancel" onClick={this.close}>
            Cancel
          </Button>,
          <Button classes="danger" key="delete" onClick={() => this.delete(record)}>
            Delete
          </Button>,
        ],
      }),
    )
  }

  select = record => {
    this.props.dispatch(showNotification(record.id, `Selecting template for: ${record.id}`))
  }

  render() {
    const { theme, ...props } = this.props
    return (
      <Container>
        <Row spacing="double">
          <Cell>
            <ListTable {...props} resource="products" title={false}>
              <Datagrid sortable={false}>
                <CombinedField
                  label="Product name"
                  cellName="product"
                  className={theme['product-col']}
                >
                  <AvatarField source={false} fallback="abbrevetation" square letter />
                  <CombinedField
                    className={`${theme['flex-vertical']} ${theme['flex-grow']} ${theme[
                      'text-left'
                    ]}`}
                  >
                    <TextField source="vendor" tag="div" />
                    <EditButton source="title" title={false} click={this.edit} theme={theme} />
                  </CombinedField>
                </CombinedField>
                <ButtonGroup width="12rem" label="Manage">
                  <ButtonField tag="div" click={this.select}>
                    <Tooltip content="Select Template">
                      <PlaneIcon fill="currentColor" width="40" height="40" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" click={this.edit}>
                    <Tooltip content="Edit product">
                      <EditIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                  <ButtonField tag="div" click={this.remove}>
                    <Tooltip content="Delete product">
                      <DeleteIcon size="2.5em" />
                    </Tooltip>
                  </ButtonField>
                </ButtonGroup>
              </Datagrid>
            </ListTable>
          </Cell>
        </Row>
      </Container>
    )
  }
}

export default Products



// WEBPACK FOOTER //
// ./view/Products/Products.js